import { useState, useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { TieredMenu } from 'primereact/tieredmenu';
import { MenuItem } from 'primereact/menuitem';
import MiniProfile from '../ReusableComponent/MiniProfile/MiniProfile';

import homeIcon from '../../assets/icons/vuesax-linear-home-2.svg';
import activitiesmg from '../../assets/icons/vuesax-linear-flag.png';
import championIcon from '../../assets/icons/vuesax-linear-cup.png';
import leagueIcon from '../../assets/icons/vuesax-linear-ranking.png';
import calenderIcon from '../../assets/icons/vuesax-linear-calendar.png';
import teamsIcon from '../../assets/icons/vuesax-linear-people.png';
import logoImg from '../../assets/images/trnmnt.svg';
import notification from './../../assets/icons/notification.svg';
import crownIcon from '../../assets/icons/crown.svg';

import { Header, NavbarContainer, UserPanel } from './Nabar.style';
import { useAppDispatch } from '../../core/hooks/hooks';
import { signOut } from '../../core/store/slices/authSlice';
import { resetDialogue, setDialogue } from '../../core/store/slices/dialogueSlice';
import logoutImg from '../../assets/icons/Group170344.png';
import { closeLoader, showLoader } from '../../core/store/slices/loaderSlice';
import { logout, markReadAllNotif } from '../../utils/api/axiosCalls';
import Spinner from '../Spinner/Spinner';
import { resetUser } from '../../core/store/slices/userSlice';
import NotificationComp from '../../pages/Notifications/NotificationComp';
import { allNotificationLoader } from '../../utils/api/reactQuery';
import { NotificationLoader } from '../../pages/Notifications/NotificationLoader';
import { ReactComponent as ProfileIcon } from '../../assets/icons/MenuIcons/vuesax-linear-profile.svg';
import { ReactComponent as HelpIcon } from '../../assets/icons/MenuIcons/vuesax-linear-message-question.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/MenuIcons/vuesax-linear-logout.svg';

const Navbar = () => {
	const { pathname } = useLocation();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const userMenu: any = useRef(null);
	const notificationMenu: any = useRef(null);

	const userData: any = localStorage.getItem('user');
	const user: any = JSON.parse(userData);

	const [loading, setLoading] = useState<boolean>(false);
	const [notifications, setNotifications] = useState<[string]>();
	const NotificationsData = notifications || [];
	const [safari, setSafari] = useState<boolean>(false);
	useEffect(() => {
		if (navigator.userAgent.match(/OS X.*Safari/) && !navigator.userAgent.match(/Chrome/)) {
			setSafari(true);
		}
	}, []);
	const HandellLogout = async () => {
		dispatch(resetDialogue());
		dispatch(showLoader({ show: true, animation: <Spinner /> }));
		try {
			await logout();
			dispatch(signOut());
			dispatch(resetUser());
			navigate('/login');
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
		}
	};

	//-------------------------------- Get Notifications ------------------------------//

	const getNotfication = async () => {
		setLoading(true);
		// dispatch(showLoader({ show: true, animation: <Spinner /> }));
		let params: any = {};
		params.new = 1;
		try {
			const res: any = await allNotificationLoader();
			setNotifications(res.records.data);
		} catch (error) {}
		// dispatch(closeLoader());
		setLoading(false);
	};

	// useEffect(() => {
	// 	getNotfication();
	// }, []);

	const handelMarkReadAll = () => {
		setLoading(true);
		try {
			markReadAllNotif();
			getNotfication();
		} catch (error) {}
		setLoading(false);
	};

	//------------------------------------------------------------------------------------

	const navBarRoutes = [
		{ lable: `${t('Home')}`, img: homeIcon, link: '' },
		{
			lable: `${t('Rounds')}`,
			img: activitiesmg,
			link: '/rounds',
		},
		{
			lable: `${t('Tournament')}`,
			img: crownIcon,
			link: '/tournament',
		},
		{
			lable: `${t('Champion Cup')}`,
			img: championIcon,
			link: '/championscup',
			disabled: true,
		},
		// {
		//   lable: `${t("League")}`,
		//   img: leagueIcon,
		//   link: "/league",
		// },
		{
			lable: `${t('Calender')}`,
			img: calenderIcon,
			link: '/calender',
		},
		{
			lable: `${t('Teams')}`,
			img: teamsIcon,
			link: '/teams',
		},
	];

	const loadingNotifications = [
		{
			template: () => (
				<div className="notificationsHeader">
					<p className="bold m-0 text-[1.25em] text-[#1E1E1E]">{t('Notifications')}</p>
				</div>
			),
		},
		{
			separator: true,
		},
		{
			template: () => <NotificationLoader />,
		},
	];

	const notificationItems: MenuItem[] = [
		{
			template: () => (
				<div className="notificationsHeader">
					<p className="bold m-0 text-[1.25em] text-[#1E1E1E]">{t('Notifications')}</p>
					<p onClick={handelMarkReadAll} className="primaryColor bold pointer m-0 text-[0.9rem]">
						{t('Mark all as read')}
					</p>
				</div>
			),
		},
		{
			separator: true,
		},
		{
			template: () =>
				NotificationsData.slice(0, 3).map((notification: any, i: number) => (
					<NotificationComp key={i} index={i} notification={notification} size="mini" />
				)),
		},

		{
			template: () => (
				<a
					href="/notifications"
					className="text-decoration-none rounded-4 rounded-top primaryColor m-0 flex h-11  cursor-pointer items-center justify-center bg-[#01ABC11A]"
				>
					{t('View all notifications')}
				</a>
			),
		},
	];

	const userItems: MenuItem[] = [
		{
			template: () => (
				<MiniProfile
					outlineColor="#01ABC1"
					offset={2}
					nameSize={18}
					emailSize={15}
					name={user.name?.split(' ').slice(0, 2).join(' ')}
					email={user.email && user.email.indexOf('@') > 4 && user.email.slice(0, 5) + '...' + user.email.slice(user.email.indexOf('@'))}
					img={`${process.env.REACT_APP_THUMBNAILS}${user.photo}`}
					preview={true}
					longEmail={user.email}
				/>
			),
		},
		{
			separator: true,
		},
		{
			label: `${t('My Profile')}`,
			icon: <ProfileIcon className="dropdown-icons" />,
			url: '/my-profile',
		},
		{
			label: `${t('Help Center')}`,
			icon: <HelpIcon className="dropdown-icons" />,
			url: '/helpCenter',
		},

		{
			label: `${t('Sign Out')}`,
			icon: <LogoutIcon className="dropdown-icons" />,

			command: () => {
				dispatch(
					setDialogue({
						show: true,
						type: 'Confirmation',
						acceptLabel: `${t('Logout')}`,
						acceptColor: '#FF4A4A',
						textColor: '#FF4A4A',
						image: logoutImg,
						hasAction: true,
						onAccept: HandellLogout,
						onReject: () => dispatch(resetDialogue()),
						rejectLabel: `${t('Cancel')}`,
						title: `${t('LogoutTitle')}`,
						text: `${t('LogoutText')}`,
					}),
				);
			},
		},
	];

	return (
		<>
			<Header>
				<NavbarContainer>
					<div className="linksContainer">
						<figure className="logoImg">
							<img src={logoImg} alt="Logo" />
						</figure>
						{navBarRoutes.map((item, index) => (
							<NavLink
								key={index}
								className={`navLink ${pathname?.startsWith(item.link) && item.lable !== 'Home' ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
								to={item.link}
							>
								<img src={item.img} alt="nav" />
								<p className="m-0 whitespace-nowrap">{item.lable}</p>
							</NavLink>
						))}
					</div>
					<UserPanel>
						<img
							onClick={(e) => {
								notificationMenu.current.toggle(e);
								getNotfication();
							}}
							src={notification}
							alt=""
							className="notification pointer-events-none cursor-default opacity-60"
						/>
						<figure onClick={(e) => userMenu.current.toggle(e)} className="user-avatar">
							<img src={`${process.env.REACT_APP_THUMBNAILS}${user.photo}`} alt="" className={`${safari ? 'user_avatar-safari' : ''}`} />
						</figure>

						<TieredMenu className="dropdown-user-menu" style={{ width: '15.5rem' }} model={userItems} popup ref={userMenu} />

						<TieredMenu
							style={{ width: '20%', minWidth: '30rem' }}
							model={loading ? loadingNotifications : notificationItems}
							popup
							ref={notificationMenu}
						/>
					</UserPanel>
				</NavbarContainer>
			</Header>
		</>
	);
};

export default Navbar;
